import type { Column as ColumnProps } from '@web/graphql-components'
import PageComponent from './PageComponent'
import { Column as PageColumn } from '@web/components/page-components/Column'
import { PageComponentProps } from '@web/components/page-components/utils'

const Column = (props: ColumnProps & PageComponentProps) => <PageColumn {...props} Component={PageComponent} />

export default Column
